export default {
    methods: {
        goToPreviousPage(){
            this.$router.back();
        }
    }
}